export const PV_TAB_LABEL = "Pressure Vessel";
export const PV_TAB_HASH_KEY = "structure-piping-pressure-vessel-tab";

/**
 * The /plant/:plantId/estimation deep link shape shared by
 * EmsProjectsTreeView's confirm-and-open flow and PlantModuleNav's "jump
 * straight to the only existing revision" links - kept in one place so both
 * stay in sync. `topTabLabel` picks the equipment tab (Structure/Piping/
 * Pressure Vessel, defaulting to Pressure Vessel); `subTabLabel` (PV only)
 * additionally picks a sub-tab (e.g. "Estimation") via the "pv-modeling"
 * hash key, since Structure/Piping have no equivalent. `wbsType` names which
 * half of the Piping module to open (Spec, Estimation, or both for a legacy
 * "pip" WBS) - see pipingWbsTabs in constants/projectTypes.js.
 */
export const buildEstimationHref = ({
  plantId,
  projectId,
  projectName,
  revision,
  topTabLabel,
  subTabLabel,
  wbsType,
  newRevision = false,
}) => {
  const resolvedTopTabLabel = topTabLabel || PV_TAB_LABEL;
  const params = new URLSearchParams({
    projectId: projectId ?? "",
    projectName: projectName || "",
    equipmentTab: resolvedTopTabLabel,
  });
  if (revision != null) {
    params.set("revision", revision);
  }
  if (wbsType) {
    params.set("wbsType", wbsType);
  }
  if (newRevision) {
    params.set("newRevision", "1");
  }
  const hash =
    `${PV_TAB_HASH_KEY}=${encodeURIComponent(resolvedTopTabLabel)}` +
    (subTabLabel ? `&pv-modeling=${encodeURIComponent(subTabLabel)}` : "");

  return `/plant/${plantId}/estimation?${params.toString()}#${hash}`;
};
